const talViewProctoringType = {
    RECORDED: 'ai_proctor',
    LIVE_PROCTOR: 'live_proctor',
    RECORD_AND_REVIEW: 'record_and_review',
};

export default talViewProctoringType;
